var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FAFAFA",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_3171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 26.3333L23.5 23M23.5 23L20.1666 26.3333M23.5 23V30.5M30.4916 28.325C31.3044 27.8819 31.9465 27.1807 32.3165 26.3322C32.6866 25.4836 32.7635 24.536 32.5351 23.6389C32.3068 22.7418 31.7862 21.9463 31.0555 21.3779C30.3248 20.8095 29.4257 20.5006 28.5 20.5H27.45C27.1977 19.5244 26.7276 18.6186 26.0749 17.8508C25.4222 17.083 24.604 16.4732 23.6817 16.0672C22.7594 15.6611 21.7571 15.4695 20.7501 15.5066C19.743 15.5437 18.7575 15.8086 17.8676 16.2814C16.9777 16.7542 16.2066 17.4226 15.6122 18.2363C15.0177 19.05 14.6155 19.9879 14.4358 20.9795C14.256 21.971 14.3034 22.9904 14.5743 23.961C14.8452 24.9317 15.3327 25.8282 16 26.5833",
    stroke: "#535862",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_3171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13.5 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.825ba10da25d7f586cbb65d64ed27bd1.svg";
export { ForwardRef as ReactComponent };